import { bool, func, oneOf, string } from 'prop-types'
import { memo } from 'react'
import styled from 'styled-components'
const StyledTextarea = styled.textarea`
	background-color: #ffffff;
	border-color: #e1e1e1;
	border-radius: 10px;
	border-style: solid;
	border-width: 1.5px;
	color: #292b32;
	font-weight: 500;
	outline: none;
	resize: vertical;
	width: 100%;
	/* 52, 44, 36 */
	font-size: 16px;
	height: 120px;
	max-height: 300px;
	min-height: 120px;
	padding: 10px 10px 10px 15px;
	&[data-size='large'] {
		font-size: 18px;
		height: 150px;
		max-height: 300px;
		min-height: 150px;
		padding: 12px 12px 12px 18px;
	}
	&[data-size='small'] {
		font-size: 14px;
		height: 90px;
		max-height: 300px;
		min-height: 90px;
		padding: 8px 8px 8px 12px;
	}
	&::placeholder {
		color: #717171;
	}
	&[data-hide-border='true'] {
		border-width: 0;
	}
	&[data-error='true']:not(:disabled) {
		border-color: #e41d32;
	}
	&:hover:not(:disabled) {
		border-color: #018ecc;
	}
	&:focus {
		border-color: #018ecc;
	}
	&:disabled {
		background-color: #f4f4f4;
		color: #717171;
		cursor: default;
	}
	.dark & {
		background-color: #2e2d2d;
		color: #e1e1e1;
		border-color: #555555;
		&[data-error='true']:not(:disabled) {
			border-color: #e41d32;
		}
		&:hover:not(:disabled) {
			border-color: #018ecc;
		}
		&:focus {
			border-color: #018ecc;
		}
		&:disabled {
			color: #717171;
		}
	}
`
const Textarea = memo(
	({
		'data-cy': dataCY,
		hideBorder = false,
		isDisabled = false,
		isError = false,
		onChange,
		onFocus,
		placeholder = '',
		ref,
		size = 'medium',
		value = '',
	}) => (
		<StyledTextarea
			className='textarea-input app-textarea'
			data-cy={dataCY}
			data-error={isError}
			data-hide-border={hideBorder}
			data-size={size}
			disabled={isDisabled}
			onChange={e => onChange(e.target.value)}
			onFocus={onFocus}
			placeholder={placeholder}
			ref={ref}
			value={value}
		/>
	)
)
Textarea.propTypes = {
	'data-cy': string,
	hideBorder: bool,
	isDisabled: bool,
	isError: bool,
	onChange: func,
	onFocus: func,
	placeholder: string,
	size: oneOf(['large', 'medium', 'small']),
	value: string,
}
export default Textarea
